module.exports = {
    apiConfig:{
        clientId :'',
        clientSecret : '',
        host : ['http://eapi.ruizhiqi.cn'],//,'http://180.76.248.165:8088/','http://180.76.170.45:8088'
        // pc原版 appid 
        //旧版
        // appid:'ef6f40f0-2087-41cc-9fd0-41be485572d7',
        //新版 提交时修改
        appid:'1af9f547-4192-41a5-ade9-794ed74e4e45',

        //退款系统 appid
        // appid:'0d1590db-dad9-4dd0-bdff-05bcb220af2e',
        hrAppid:'338160aa-e8fd-43bb-bb53-92d7e6a5597b',
        key:'asrtfgdsfgdfhjkh',
        // localHost:"http://localhost:8889/",
        // localHost:"http://refund.text.ruizhiqi.com?jump=/Refund/Refund",
    }
}